<template>
	<read-document />
</template>
<script>
import ReadDocument from '@/components/agreement/readDocumentByLegal/ReadDocument.vue';

export default {
	name: 'ReadDocumentByLegalView',
	components: { ReadDocument },
};
</script>
